<script setup lang="ts">
import {
  QUALITY_RECORD_HEADER_CLASS,
  QUALITY_RECORD_HEADER_LOGO_CLASS,
  QUALITY_RECORD_HEADER_LABEL_CLASS,
  QUALITY_RECORD_HEADER_CODE_CLASS,
  QUALITY_RECORD_HEADER_REVISION_CLASS,
  qualityRecordHeaderTitleClass,
} from '@/shared/lib/print';

const props = withDefaults(
  defineProps<{
    documentInfo: {
      code?: string;
      revision?: string;
      documentNumber?: string;
      documentPrefix?: string;
    };
    title: string;
    qualityRecordCode?: string;
    mainLabel?: string;
    logoUrl: string;
  }>(),
  {
    mainLabel: 'REGISTRO DA QUALIDADE',
  }
);

const emit = defineEmits<{ logoError: [] }>();
</script>

<template>
  <table
    id="document-info-header"
    :class="`w-full border-collapse mb-6 ${QUALITY_RECORD_HEADER_CLASS}`"
  >
    <thead class="hidden" />
    <tbody>
      <tr>
        <td
          rowspan="2"
          :class="`border border-gray-400 py-4 w-60 text-center bg-white-01 ${QUALITY_RECORD_HEADER_LOGO_CLASS}`"
        >
          <div class="flex flex-col items-center">
            <img
              :src="logoUrl"
              alt="Logo"
              data-print-logo
              class="max-w-[170px] max-h-[84px]"
              @error="emit('logoError')"
            />
          </div>
        </td>
        <td :class="`border border-gray-400 p-4 text-center ${QUALITY_RECORD_HEADER_LABEL_CLASS}`">
          <div class="text-lg font-semibold text-gray-800">
            {{ mainLabel }}
          </div>
          <div
            v-if="qualityRecordCode"
            class="text-sm text-gray-600 mt-1"
          >
            {{ qualityRecordCode }}
          </div>
        </td>
        <td :class="`border border-gray-400 p-4 text-center w-44 bg-white-01 ${QUALITY_RECORD_HEADER_CODE_CLASS}`">
          <div class="text-sm font-semibold">
            {{ documentInfo.code }}
          </div>
        </td>
        <td
          :class="`border border-gray-400 p-4 text-center w-44 bg-white-01 ${QUALITY_RECORD_HEADER_REVISION_CLASS}`"
        >
          <div class="text-sm font-semibold">
            {{ documentInfo.revision }}
          </div>
        </td>
      </tr>
      <tr>
        <td
          colspan="3"
          class="border border-gray-400 p-4 text-center"
        >
          <div :class="`text-lg font-semibold text-gray-800 ${qualityRecordHeaderTitleClass(props.title)}`">
            {{ title }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
